import { axios } from '@/utils/request'

const api = {

    purchaseEdit: '/adminapi/jxc/purchaseEdit',
    purchaseGoodsEdit: '/adminapi/jxc/purchaseGoodsEdit',
    purchaseAdd: '/adminapi/jxc/purchaseAdd',
    purchaseGoodsAdd: '/adminapi/jxc/purchaseGoodsAdd',
    goodsOptions: '/adminapi/jxc/goodsOptions',
    goodsSkuDetail: '/adminapi/jxc/goodsSkuDetail',
    purchaseDetail: '/adminapi/jxc/purchaseDetail',
    purchaseList: '/adminapi/jxc/purchaseList',
    purchaseGoodsList: '/adminapi/jxc/purchaseGoodsList',
    purchaseRankEdit: '/adminapi/jxc/tuanRankEdit',
    purchaseDelete: '/adminapi/jxc/tuanDelete',
    setPurchaseAllStatus: '/adminapi/jxc/setTuanAllStatus',
    purchaseOrderList: '/badminapi/jxc/orderList',

    purchaseGoodsDelete: '/adminapi/jxc/purchaseGoodsDelete',
    supplyOption: '/adminapi/jxc/supplyOption',
    purchaseGoodsDetail: '/adminapi/jxc/purchaseGoodsDetail',

    inventoryCheckEdit: '/adminapi/jxc/inventoryCheckEdit',
    inventoryCheckAdd: '/adminapi/jxc/inventoryCheckAdd',
    getInventoryCheckList: '/adminapi/jxc/inventoryCheckList',
    inventoryCheckDetail: '/adminapi/jxc/inventoryCheckDetail',
    getCheckTypeOption: '/adminapi/jxc/getCheckTypeOption',
    checkGoodsEdit: '/adminapi/jxc/checkGoodsEdit',
    checkGoodsAdd: '/adminapi/jxc/checkGoodsAdd',
    checkGoodsList: '/adminapi/jxc/checkGoodsList',
    checkGoodsDetail: '/adminapi/jxc/checkGoodsDetail',
    checkGoodsDelete: '/adminapi/jxc/checkGoodsDelete',
    checkGoodsExamine: '/adminapi/jxc/checkGoodsExamine',
    editSale: '/wyhadminapi/jxc/salesEdit',
    addSale: '/wyhadminapi/jxc/salesAdd',
    saleDetail: '/adminapi/jxc/saleDetail',
    getSaleList: '/wyhadminapi/jxc/getSaleList',

    saleGoodsEdit: '/adminapi/jxc/saleGoodsEdit',
    saleGoodsAdd: '/adminapi/jxc/saleGoodsAdd',
    saleGoodsList: '/adminapi/jxc/saleGoodsList',
    saleGoodsDetail: '/adminapi/jxc/saleGoodsDetail',
    saleGoodsDelete: '/adminapi/jxc/saleGoodsDelete',

    getSaleUserList: '/adminapi/jxc/getSaleUserList',
    saleDelete: '/adminapi/jxc/saleDelete',

    userList: '/adminapi/jxc/userlist',

    getWithdrawalList: '/wyhadminapi/order/withdrawalList',
    withdrawalStatusEdit: '/wyhadminapi/order/withdrawalStatusEdit',
    addWithdrawal: '/wyhadminapi/order/addWithdrawal',
    deleteWithdrawal: '/wyhadminapi/order/deleteWithdrawal',

}

export default api
export function deleteWithdrawal(parameter) {
    return axios({
        url: api.deleteWithdrawal,
        method: 'post',
        data: parameter
    })
}
export function addWithdrawal(parameter) {
    return axios({
        url: api.addWithdrawal,
        method: 'post',
        data: parameter
    })
}
export function withdrawalStatusEdit(parameter) {
    return axios({
        url: api.withdrawalStatusEdit,
        method: 'post',
        data: parameter
    })
}

export function getWithdrawalList(parameter) {
    return axios({
        url: api.getWithdrawalList,
        method: 'get',
        params: parameter
    })
}

export function getUserList(parameter) {
    return axios({
        url: api.userList,
        method: 'get',
        params: parameter
    })
}

export function saleDelete(parameter) {
    return axios({
        url: api.saleDelete,
        method: 'get',
        params: parameter
    })
}

export function getSaleUserList(parameter) {
    return axios({
        url: api.getSaleUserList,
        method: 'get',
        params: parameter
    })
}

export function saleGoodsDetail(parameter) {
    return axios({
        url: api.saleGoodsDetail,
        method: 'get',
        params: parameter
    })
}

export function saleGoodsDelete(parameter) {
    return axios({
        url: api.saleGoodsDelete,
        method: 'get',
        params: parameter
    })
}

export function saleGoodsList(parameter) {
    return axios({
        url: api.saleGoodsList,
        method: 'get',
        params: parameter
    })
}

export function saleGoodsEdit(parameter) {
    return axios({
        url: api.saleGoodsEdit,
        method: 'post',
        data: parameter
    })
}
export function saleGoodsAdd(parameter) {
    return axios({
        url: api.saleGoodsAdd,
        method: 'post',
        data: parameter
    })
}

export function saleDetail(parameter) {
    return axios({
        url: api.saleDetail,
        method: 'get',
        params: parameter
    })
}

export function getSaleList(parameter) {
    return axios({
        url: api.getSaleList,
        method: 'get',
        params: parameter
    })
}

export function editSale(parameter) {
    return axios({
        url: api.editSale,
        method: 'post',
        data: parameter
    })
}
export function addSale(parameter) {
    return axios({
        url: api.addSale,
        method: 'post',
        data: parameter
    })
}

export function checkGoodsExamine(parameter) {
    return axios({
        url: api.checkGoodsExamine,
        method: 'post',
        data: parameter
    })
}

export function checkGoodsDelete(parameter) {
    return axios({
        url: api.checkGoodsDelete,
        method: 'get',
        params: parameter
    })
}

export function checkGoodsDetail(parameter) {
    return axios({
        url: api.checkGoodsDetail,
        method: 'get',
        params: parameter
    })
}

export function checkGoodsList(parameter) {
    return axios({
        url: api.checkGoodsList,
        method: 'get',
        params: parameter
    })
}

export function checkGoodsEdit(parameter) {
    return axios({
        url: api.checkGoodsEdit,
        method: 'post',
        data: parameter
    })
}
export function checkGoodsAdd(parameter) {
    return axios({
        url: api.checkGoodsAdd,
        method: 'post',
        data: parameter
    })
}

export function getCheckTypeOption(parameter) {
    return axios({
        url: api.getCheckTypeOption,
        method: 'get',
        params: parameter
    })
}

export function inventoryCheckDetail(parameter) {
    return axios({
        url: api.inventoryCheckDetail,
        method: 'get',
        params: parameter
    })
}

export function getInventoryCheckList(parameter) {
    return axios({
        url: api.getInventoryCheckList,
        method: 'get',
        params: parameter
    })
}

export function inventoryCheckEdit(parameter) {
    return axios({
        url: api.inventoryCheckEdit,
        method: 'post',
        data: parameter
    })
}
export function inventoryCheckAdd(parameter) {
    return axios({
        url: api.inventoryCheckAdd,
        method: 'post',
        data: parameter
    })
}

export function purchaseGoodsDetail(parameter) {
    return axios({
        url: api.purchaseGoodsDetail,
        method: 'get',
        params: parameter
    })
}
export function purchaseGoodsDelete(parameter) {
    return axios({
        url: api.purchaseGoodsDelete,
        method: 'get',
        params: parameter
    })
}

export function purchaseEdit(parameter) {
    return axios({
        url: api.purchaseEdit,
        method: 'post',
        data: parameter
    })
}
export function purchaseAdd(parameter) {
    return axios({
        url: api.purchaseAdd,
        method: 'post',
        data: parameter
    })
}

export function purchaseGoodsEdit(parameter) {
    return axios({
        url: api.purchaseGoodsEdit,
        method: 'post',
        data: parameter
    })
}
export function purchaseGoodsAdd(parameter) {
    return axios({
        url: api.purchaseGoodsAdd,
        method: 'post',
        data: parameter
    })
}

export function purchaseGoodsList(parameter) {
    return axios({
        url: api.purchaseGoodsList,
        method: 'get',
        params: parameter
    })
}

export function purchaseList(parameter) {
    return axios({
        url: api.purchaseList,
        method: 'get',
        params: parameter
    })
}
export function purchaseDetail(parameter) {
    return axios({
        url: api.purchaseDetail,
        method: 'get',
        params: parameter
    })
}
export function getGoodsOptions(parameter) {
    return axios({
        url: api.goodsOptions,
        method: 'get',
        params: parameter
    })
}
export function getGoodsSkuDetail(parameter) {
    return axios({
        url: api.goodsSkuDetail,
        method: 'get',
        params: parameter
    })
}


export function deleteTuan(parameter) {
    return axios({
        url: api.tuanDelete,
        method: 'post',
        data: parameter
    })
}

export function setTuanRank(parameter) {
    return axios({
        url: api.tuanRankEdit,
        method: 'post',
        data: parameter
    })
}


export function setTuanAllStatus(parameter) {
    return axios({
        url: api.setTuanAllStatus,
        method: 'post',
        data: parameter
    })
}
export function getTuanUserList(parameter) {
    return axios({
        url: api.tuanOrderList,
        method: 'post',
        data: parameter
    })
}